import { memo } from 'react';
import { IconTrash } from '@tabler/icons-react';
import { SCENE_OPTION_MENU_ITEM_COMMON_CLASSNAME } from '../SceneOptionsMenuConstants';
import { useDeleteScene } from '../../useDeleteScene';

function SceneOptionsMenuDelete({ sceneId, compositeId }: { sceneId: string; compositeId: string }) {
  const { deleteScene } = useDeleteScene();

  const handleRemoveScene = () => {
    deleteScene(sceneId, compositeId);
  };

  return (
    <button className={`${SCENE_OPTION_MENU_ITEM_COMMON_CLASSNAME}`} onClick={handleRemoveScene}>
      <div className="flex items-center gap-2">
        <IconTrash className="size-4" />
        Remove scene
      </div>
      <span />
    </button>
  );
}

export default memo(SceneOptionsMenuDelete);
